<template>
    <v-layout column _signup-layout>
        <SignupHeader :user="user" class="signup-header-fixed"></SignupHeader>

        <v-flex class="signup-form-container">
            <v-container>
                <v-layout column justify-center text-xs-center>
                  <!--EMAIL-->
                    <v-flex class="d-flex justify-center">
                      <v-layout column
                                class="_signup-layout--form">
                        <v-select
                          v-model="user.role"
                          :items="roles"
                          label="I want to*"
                          item-text="label"
                          item-value="key"
                          v-validate="'required'"
                          :error-messages = "errors.first('role')"
                          data-vv-name="role"
                          :menu-props="{offsetY: true}"
                          outline
                          disabled
                          ref="role"
                        ></v-select>
                        <v-flex xs12 sm6>
                          <v-text-field label="Email*"
                                        v-model="user.email"
                                        v-validate="'required|email'"
                                        :error-messages="errors.first('email')"
                                        data-vv-name="email"
                                        ref="email"
                                        solo></v-text-field>
                        </v-flex>
                        <!-- <v-flex xs12 sm6>
                          <v-text-field label="Confirm Email*"
                                        v-model="emailConfirm"
                                        v-validate.disbaled="'confirmed:email'"
                                        :error-messages="errors.first('email_confirm')"
                                        data-vv-name="email_confirm"
                                        solo></v-text-field>
                        </v-flex> -->
                        <v-flex xs12 sm6>
                          <v-text-field label="Password*"
                                        v-model="user.password"
                                        v-validate="'required|min:6'"
                                        :error-messages="errors.first('password')"
                                        data-vv-name="password"
                                        type="password"
                                        ref="password"
                                        solo></v-text-field>
                        </v-flex>
                        <!-- <v-checkbox v-model="user.is_emailme"
                                    class="mt-0"
                                    :ripple="false">
                          <template slot="label">
                            <div class="text-small v-label" style="font-size: 14px;">Email me NannyGranny updates</div>
                          </template>
                        </v-checkbox> -->
                        <v-flex ref="wwc_check"  v-bind:class="{ 'www-check': this.user.role=='nanny', 'www-check-hidden': this.user.role=='parent' }">
                          <p class="text-left v-label theme--light" style="font-size: 14px;">Do you have a WWC check</p>

                          <v-radio-group :data-vv-rules="user.role === 'nanny' ? 'required' : ''" v-model="user.is_valid_wwc_check" v-validate="'required'" @change="showWwcDialog" ref="wwc_check">
                            <v-radio
                              label="I have a valid WWC check"
                              :value="0"
                            ></v-radio>

                            <v-radio
                              label="No, I do not have a valid WWC check"
                              :value="1"
                            ></v-radio>
                          <span v-if="errors.has('wwc_check')" class="error--text">{{ errors.first('wwc_check') }}</span>
                          </v-radio-group>
                        </v-flex>
                        <v-checkbox v-validate="'required'"
                                    v-model="user.is_agreepp"
                                    :error-messages="errors.collect('is_agreepp')"
                                    value="1"
                                    class="terms-and-cond"
                                    data-vv-name="is_agreepp"
                                    type="checkbox"
                                    ref="agreepp"
                                    :ripple="false">
                          <template slot="label">
                            <div class="text-small tnctext">
                              By joining I agree to the&nbsp;
                              <a href="#"
                                 @click.stop.prevent="dialogShow('policy')"
                                 class="link-small">
                                Participation Agreement
                              </a>
                              &nbsp;and the&nbsp;
                              <a href="#"
                                 @click.stop.prevent="dialogShow('legal')"
                                 class="link-small">
                                Terms of use
                              </a>
                            </div>
                          </template>
                        </v-checkbox>
                        <v-flex _signup-layout--actions>
                          <v-btn color="secondary" outlined to="/register">
                            Back
                          </v-btn>
                          <v-btn @click="register"
                                 :loading="loading"
                                 :disabled="user.is_valid_wwc_check === 1"
                                 class="primary v-btn--default elevation-0">
                            Get started
                          </v-btn>
                        </v-flex>
                        <v-flex>
                          <h3>
                              <span>Already have an account?</span>
                              <router-link to="/login" tag="a" class="link-small">Login here</router-link>
                          </h3>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <!--DIVIDER-->
                    <!--<v-flex class="_signup-layout--divider">
                        <app-svg-icon name="brand/NG_DIVIDER"></app-svg-icon>
                        <h3 class="font--medium d-inline-block mx-4">or</h3>
                        <app-svg-icon name="brand/NG_DIVIDER"></app-svg-icon>
                    </v-flex> -->
                    <!--SOCIAL-->
                    <!--<v-flex>
                      <auth-social :input-role="user.role"
                                 class="column"
                                 register></auth-social>
                    </v-flex>-->
                </v-layout>
            </v-container>
        </v-flex>
        <v-dialog v-model="dialog.show"
                  :fullscreen="$vuetify.breakpoint.xsOnly"
                  max-width="750">
            <v-card>
                <v-card-text v-html="dialog.text"></v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn flat
                           @click="user.is_agreepp = null, dialog.show = false">
                        No
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn class="white--text"
                           color="primary accent-4"
                           @click="user.is_agreepp = '1', dialog.show = false">
                        Yes
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="wwcDialog"
                  :fullscreen="$vuetify.breakpoint.xsOnly"
                  max-width="750">
            <v-card>
              <v-card-text>
                <div class="donotHaveWwcCheck text-left">
                  <p>Learn about the Working With Children Check in your state and how to apply for certification using the links below.</p>

                  <ul class="donotWwcCheckList">
                    <li><a target="_blank" href="https://www.service.nsw.gov.au/transaction/apply-working-children-check">New South Wales</a></li>
                    <li><a target="_blank" href="https://www.qld.gov.au/law/laws-regulated-industries-and-accountability/queensland-laws-and-regulations/regulated-industries-and-licensing/blue-card-services">Queensland</a></li>
                    <li><a target="_blank" href="https://www.workingwithchildren.vic.gov.au/">Victoria</a></li>
                    <li><a target="_blank" href="https://screening.sa.gov.au/">South Australia</a></li>
                    <li><a target="_blank" href="https://workingwithchildren.wa.gov.au/">Western Australia</a></li>
                    <li><a target="_blank" href="https://nt.gov.au/emergency/community-safety/apply-for-a-working-with-children-clearance">Northern Territory</a></li>
                    <li><a target="_blank" href="https://wwcforms.justice.tas.gov.au/Apply/ApplicationStart.aspx">Tasmania</a></li>
                    <li><a target="_blank" href="https://www.accesscanberra.act.gov.au/s/article/working-with-vulnerable-people-wwvp-registration-tab-overview">ACT</a></li>
                  </ul>
                </div>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn  flat
                            color="secondary outline"
                           @click="wwcDialog = false">
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
  import AppScrollPatterns from '../../../../../components/app-scroll-patterns'
  import AuthSocial from '../../components/auth-social'
  import { register as mutations } from '@/store/types/mutation-types'
  import { AUTH_KEY } from '@/config/constants'
  import AppAuthBenefits from '../../components/app-auth-benefits'
  import SignupHeader from '../components/auth-signup-header'

  export default {
    name: 'auth-signup-register',

    components: {AppScrollPatterns, AppAuthBenefits, AuthSocial, SignupHeader},

    data () {
      return {
        roles: [
          { key: 'nanny', label: 'Become a NannyGranny' },
          { key: 'parent', label: 'Find a NannyGranny' }
        ],
        user: {
          role: this.$route.query.role || 'parent',
          email: '',
          password: '',
          is_emailme: null,
          is_agreepp: null,
          is_valid_wwc_check: this.$route.query.role === 'nanny' ? null : 0
        },
        emailConfirm: null,
        showPassword: false,
        wwcDialog: false,
        dialog: {
          show: false,
          text: ''
        },
        dictionary: {
          attributes: {
            email_confirm: 'email confirm',
            is_agreepp: 'agreement'
          },
          custom: {
            email_confirm: {
              confirmed: 'The email confirmation does not match.'
            }
          }
        }
      }
    },

    computed: {
      loading () {
        return this.$store.getters['register/loading']
      },
      stepperType () {
        return this.user.role
      },
      policy () {
        return this.$store.getters['page/content']('participation-agreement')[0]
      },
      legal () {
        return this.$store.getters['page/content']('legal')[0]
      }
    },

    watch: {
      stepperType () {
        this.$store.commit('register/' + mutations.REGISTER_STEPPER_TYPE, this.stepperType)
      }
    },

    created () {
      this.$store.commit('register/' + mutations.REGISTER_STEPPER_TYPE, this.stepperType)
    },

    mounted () {
      this.$validator.localize('en', this.dictionary)
    },

    methods: {
      showWwcDialog () {
        this.wwcDialog = this.user.is_valid_wwc_check ? true : false
      },
      dialogShow (type) {
        this.dialog.show = true
        this.dialog.text = this[type].description
      },
      scrollToField(field)
      {
        const el = this.$refs[field].$el || this.$refs[field]
        el.scrollIntoView({ behavior: 'smooth', block: 'center' })
        el.focus()
      },
      register () {
        if (this.$auth.token()) {
          localStorage.removeItem(AUTH_KEY)
        }

        if (this.user.role === 'nanny' && this.user.is_valid_wwc_check === null) {
          this.errors.add({ field: 'wwc_check', msg: 'WWC check selection is required' });
        }

        this.$validator.validateAll().then(result => {
          if (!result) {
            const invalidField = this.errors.items[0].field
            this.scrollToField(invalidField)
          } 
          else {
            this.$store.dispatch('register/STEP_1', {data: this.user})
                .then(() => {
                  this.$router.push(`signup/step-2/${this.user.role}`)
                })
                .catch((error) => {
                  if (error.response.status === 422) {
                    this.$lodash.forEach(error.response.data.errors, (val, key) => {
                      this.errors.add({
                        field: key,
                        msg: val[0]
                      })
                    })
                  }
                })
          }
        })
      }
    }
  }
</script>
<style lang="stylus">
  .terms-and-cond 
    .v-input__slot
      margin-bottom 0px !important; 
</style>
<style lang="stylus" scoped>
    .www-check
        margin-left 32px
    .www-check-hidden
        margin-left 32px 
        visibility hidden
        display none   
    .text-left
        text-align left
    
    .tnctext
      font-size 1rem
    ._signup-layout
        margin-bottom 150px
        &--subheader
            margin 90px 0 50px
        &--subheader_second
            margin-bottom 60px
        &--actions
            margin 0px 0 15px
        &--form
            max-width 380px
            margin-top 30px
        &--divider
            @media (min-width 600px)
                margin-top 15px
                margin-bottom 3px
            .svg-icon
                width 100px
                height 50px
                color var(--yellow)
                @media (min-width 600px)
                    width 139px
        &--benefits-section
            position relative
            overflow-x hidden
    .donotWwcCheckList
      li
        a
          text-decoration none

    .v-input--selection-controls
      margin-top 0px !important
      padding-top 0px !important
</style>



// WEBPACK FOOTER //
// src/views/app/auth/signup/components/auth-signup-step-1.vue